enum StandbyState {
  UNKNOWN = 'unknown',
  INACTIVE = 'inactive',
  ACTIVE = 'active',
}

export default StandbyState
